import { Routes, Route } from "react-router-dom";
import GuestLayout from "./GuestLayout";
import UserTaasnetpage from "../components/Dashboard/User/Homepage/UserTaasnetpage";
import TalentPage from "../pages/Talent/TalentPage";
import SignIn from "../pages/Auth/SignIn";
import Register from "../pages/Register/Register";
import ForgotPasswordPage from "../pages/Auth/ForgotPassword";
import VerifyEmailPage from "../pages/Auth/VerifyPage";
import PasswordResetPage from "../pages/Auth/ResetPassword";
import Homepage from "../pages/LandingPage/Home";
import AboutPage from "../pages/LandingPage/AboutPage";
import ContactPage from "../pages/LandingPage/contacts/Contactpage";
import SupportPage from "../components/Support/SupportPage";
import FeaturedEventDetail from "../components/Dashboard/Talent/Card/Featured_Card/FeaturedEventDetail";
import withOutAuthentication from "../hoc/withOutAuthentication";
import ComingSoon from "../pages/LandingPage/ComingSoon";
import BusinessChoiceLanding from "../components/BusinessAccount/Register/BussinessChoiceLanding";
import BusinessAccountWrapper from "../components/BusinessAccount/Register/BussinessAccountWrapper";
const GuestLayoutWrapper = withOutAuthentication(GuestLayout);

const GuestRoutes = () => {
  return (
    <Routes>
      {/* Public landing pages */}
      <Route path="/" element={<Homepage />} />
      <Route path="/home" element={<Homepage />} />
      <Route path="/home/business-choice" element={<BusinessChoiceLanding />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/coming-soon" element={<ComingSoon />} />

      {/* Auth routes */}
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/business" element={<BusinessAccountWrapper />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/signup/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password?/OTP" element={<VerifyEmailPage />} />
      <Route
        path="/forgot-password/reset-password"
        element={<PasswordResetPage />}
      />

      {/* Guest layout routes - accessible without authentication */}
      <Route path="/" element={<GuestLayoutWrapper />}>
        <Route path="guest" element={<UserTaasnetpage />} />
        <Route path="talent/profile/:id" element={<TalentPage />} />
        <Route path="featured-event/:id" element={<FeaturedEventDetail />} />
        <Route path="*" element={<h1>Page not found</h1>} />
      </Route>
      <Route path="*" element={<h1>Page not found</h1>} />
    </Routes>
  );
};

export default GuestRoutes;
